export default __webpack_public_path__ + "static/media/wallet.093cad62.png";